import { Checkbox } from "@mui/material"
import PropTypes from "prop-types"

export default function CheckboxElement({ isChecked, isDisabled, className, isHidden }) {
  if (isHidden) {
    return <div className="checkbox-placeholder" />
  }
  return <Checkbox
    color="primary"
    className={className}
    // Need to set tabIndex to -1 because the parent element is a button that controls the checkbox state
    tabIndex={-1}
    checked={isChecked}
    disabled={isDisabled}
    disableRipple
  />
}

CheckboxElement.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  className: PropTypes.string.isRequired,
  isHidden: PropTypes.bool.isRequired,
}
